module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DashboardItem__icon-right"
  }, [_c('i', {
    staticClass: "icon-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DashboardItem",
    on: {
      "click": function($event) {
        _vm.click($event.target)
      }
    }
  }, [_c('div', {
    staticClass: "DashboardItem__icon"
  }, [_c('i', {
    class: [_vm.icon]
  })]), _vm._v(" "), _c('div', {
    staticClass: "DashboardItem__header"
  }, [_vm._v(_vm._s(_vm.translate(_vm.name)))]), _vm._v(" "), _vm._m(0)])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3eae6a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/DashboardItem.vue
// module id = 526
// module chunks = 1